// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-popup-footer[data-v-5a6c38d2]{position:fixed;left:0;right:0;bottom:0;padding:16px 16px 32px;background-color:#fff;box-shadow:0px 0px 6px rgba(51,51,51,.3)}.event-popup-footer__inner[data-v-5a6c38d2]{width:343px;margin:0 auto}.event-popup-footer__next[data-v-5a6c38d2]{margin-top:12px;text-align:center}.event-popup-footer__next a[data-v-5a6c38d2]{font-weight:600;font-size:12px;line-height:20px;color:#6d7780;cursor:pointer}", ""]);
// Exports
module.exports = exports;
